import React, { useState, useEffect, useCallback } from 'react';
import { Container, Box, Paper, ButtonGroup, Button } from '@mui/material';
import AddTxtField from '../../../common/AddTxtField';
import Service from '../../../../util/Service';

// export default function UserTaskFormCDN(props) {
const UserTaskFormCDN = React.forwardRef((props, ref) => {
    const { setCDN, cdn, item, processo } = props;
    const [uri, setUri] = useState(cdn ? cdn : '');
    const handleCDN = () => {
        setCDN(uri);
        console.log(uri)
    }

    React.useEffect(() => {
        console.log(cdn)
    }, [cdn])

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            handleSalva();
          }
    }))

    const handleSalva = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,
            cdn: uri
        }

        Service.POST('/api/bpmn/salvarTaskDoProcesso', dado).then(resp => {
            // setWait(false);
            // onClose();
        }).catch(error => {
            console.error(error)
            // setWait(false);
            // setMensagem(error ? error : 'Oops! Something went wrong. Please try again!');
        })
    }
    return (
        <div>
            <Box sx={{ maxWidth: 400, marginLeft: "10px", marginTop: 1 }}>
                <AddTxtField label="adicionar um CDN" txt={uri} setTxt={setUri} action={handleCDN} />
            </Box>
            <ButtonGroup variant="outlined" aria-label="text button group">
                <Button color='inherit' onClick={handleSalva}>Salvar</Button>
            </ButtonGroup>
            <Paper variant="outlined">
                <iframe id="iframe" src={cdn} style={{ border: "none" }} height="400" width="800" title="TesteIFrame"></iframe>
            </Paper>

        </div>
    )
})

export default UserTaskFormCDN;